export const DEFAULT_ASSET_UPLOAD_CAPACITY = 50;

export function getAssetUploadCapacity(config = {}) {
  const value = config?.assetUploadCapacity;
  const capacity = typeof value === "number" || typeof value === "string" ? Number(value) : NaN;
  return Number.isFinite(capacity) && capacity > 0 ? capacity : DEFAULT_ASSET_UPLOAD_CAPACITY;
}

/** Preserve scene settings while validating the upload limit in MB. */
export function normalizeRuntimeSettings(runtimeSettings = {}) {
  const settings = { ...runtimeSettings };
  if (Object.prototype.hasOwnProperty.call(settings, "assetUploadCapacity")) {
    settings.assetUploadCapacity = getAssetUploadCapacity(settings);
  }
  return settings;
}
